import { createSyncAction } from '@bimser/core';
import { DEPLOY_AGENT_MESSAGE_ACTION } from './actionTypes';
import {
	IDeployAgentMessage,
	DeployAgentMessageFactoryFromJS
} from '../entities/DeployAgentEntities/DeployAgentMessage';

const deployAgentMessageAction = (payload: IDeployAgentMessage) =>
	createSyncAction(DEPLOY_AGENT_MESSAGE_ACTION, DeployAgentMessageFactoryFromJS(payload));
export default deployAgentMessageAction;
